import { api } from './../../api.js';

import axios from 'axios';

const state = {
	
}

const getters = {
	
}

const mutations = {
	
}

const actions = {

	getFAQS : function({ commit }, data){

		return new Promise((resolve, reject) => {
			var params = {
				filters : data.filters
			}

			api.get('admin/faqs', params).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			});
		});
	},
	getFAQ : function({ commit }, data){
		return new Promise((resolve, reject) => {
			var params = {
				filters : data.filters
			}

			api.get('admin/faqs/'+data.id, params).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			});
		});
	},

	createFAQ : function({ commit }, data){

		return new Promise((resolve, reject) => {

			api.post('admin/faqs', data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			});
		});
	},

	editFAQ : function({ commit }, data){

		return new Promise((resolve, reject) => {
			api.patch('admin/faqs/'+data.id, data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			});
		});
	},

	deleteFAQ : function({ commit }, data){

		return new Promise((resolve, reject) => {
			api.delete('admin/faqs/'+data.id, data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			});
		});
	}
}

export default {
	state, 
	actions,
	getters,
	mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/FAQModule.js